const search = () => {
	// animation of typing text
	const typeJsText = document.querySelector('.js-typing-text');

	if (typeJsText) {
		let textArray = typeJsText.dataset.typetext.split('');
		let counter   = -1;

		typeJsText.innerHTML = '';

		function typeJs() {
			if (counter < typeJsText.dataset.typetext.length) {
				counter++;
				typeJsText.innerHTML += typeJsText.dataset.typetext.charAt(counter);
				textArray = typeJsText.dataset.typetext.split('');
			} else {
				textArray.pop();
				typeJsText.innerHTML = textArray.join('');
				if (textArray.length == 0) {
					counter = -1;
				}
			}
		}

		setInterval(() => {
			typeJs();
		}, 100);

		// open search block
		const openSearch  = document.querySelector('[data-search="open"]');
		const blockSearch = document.querySelector('[data-search="block"]');

		openSearch.addEventListener('click', () => {
			blockSearch.classList.add('is-open');
			blockSearch.scrollIntoView({
				behavior : 'smooth',
				block    : 'center',
			});
		});
	}
};
export default search;
